import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import AiAssistantCommand from './ai-assistantcommand';

export default class AiAssistantEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add(
      'aiAssistant',
      new AiAssistantCommand(editor)
    );
  }
}
